import i18n from '../../../../../locales/i18n';

const getRoutesAndTitles = (isPartner, lastSearch, partnerCompanies, resourceId, user, setLastSearch, options = {}) => {
  const { clockingDeviceSiteName } = options;
  let titles = [];
  let routes = [];

  const basePath = location.pathname.replace(window.env.PUBLIC_URL, ''); // Ex : remove "/comete" from pathname
  const onePartner = partnerCompanies?.length > 1;

  // Espace manager : gestion des routes dynamiques MCE
  // TODO: Supprimer après démonstration de vendredi 19 décembre 2025
  if (basePath.startsWith('/mce/manager/entry/')) {
    setLastSearch(location.search);
    titles = ['Formulaires', 'MCE rempli', 'Détails'];
    routes = ['/', '/mce/manager/forms', '/mce/manager/entries', location.pathname];
    return { routes, titles };
  }

  // Espace manager : gestion de l'édition de formulaire avec ID dynamique
  if (basePath.startsWith('/mce/manager/forms/update/')) {
    titles = ['Formulaires MCE', 'Modifier un formulaire'];
    routes = ['/', '/mce/manager/forms', location.pathname];
    return { routes, titles };
  }

  // Espace manager : création / reprise de brouillon d'une ronde
  if (basePath.startsWith('/mce/manager/patrols/create')) {
    titles = ['Rondes', 'Créer une ronde'];
    routes = ['/', '/mce/manager/patrols', location.pathname];
    return { routes, titles };
  }

  // Espace manager : modification d'une ronde existante
  if (basePath.startsWith('/mce/manager/patrols/update/')) {
    titles = ['Rondes', 'Modifier une ronde'];
    routes = ['/', '/mce/manager/patrols', location.pathname];
    return { routes, titles };
  }

  // Espace agent : détail d'un évènement (formulaire à remplir)
  if (basePath.startsWith('/mce/resource/events/fill/')) {
    titles = ['Évènements', 'Évènement'];
    routes = ['/', '/mce/resource/events', location.pathname];
    return { routes, titles };
  }

  // Espace agent : déclaration d'une ronde active (app principale et OnTime)
  if (basePath.startsWith('/pointages/mce/resource/patrols/')) {
    titles = ['Rondes', 'Ronde'];
    routes = ['/', '/pointages/mce/resource/patrols', location.pathname];
    return { routes, titles };
  }
  if (basePath.startsWith('/mce/resource/patrols/')) {
    titles = ['Rondes', 'Ronde'];
    routes = ['/', '/mce/resource/patrols', location.pathname];
    return { routes, titles };
  }

  // Admin : détail utilisateur (nom dynamique stocké par la page)
  if (basePath.startsWith('/admin/users/edit/')) {
    const userName = sessionStorage.getItem('breadcrumb:admin-user-name') || 'Détail utilisateur';
    titles = ['Utilisateurs', userName];
    routes = ['/', '/admin/users', location.pathname];
    return { routes, titles };
  }

  switch (basePath) {
    // Shared pages
    case '/about':
      titles = ['À propos'];
      routes = ['/', location.pathname];
      break;
    case '/privacy-policy': {
      const fromAbout = new URLSearchParams(location.search).get('from') === 'about';
      titles = fromAbout ? ['À propos', 'Politique de confidentialité'] : ['Politique de confidentialité'];
      routes = fromAbout ? ['/', '/about', location.pathname + location.search] : [location.pathname + location.search];
      break;
    }

    case '/research-group': {
      const fromAbout = new URLSearchParams(location.search).get('from') === 'about';
      titles = fromAbout ? ['À propos', 'Groupe de recherche'] : ['Groupe de recherche'];
      routes = fromAbout ? ['/', '/about', location.pathname + location.search] : [location.pathname + location.search];
      break;
    }
    case '/demand':
      titles = ['Demandes', 'Demande'];
      routes = ['/', `/demands${isPartner ? '/partner' : ''}`, location.pathname];
      break;
    case '/documents':
      titles = ['Documents'];
      routes = ['/', location.pathname];
      break;
    case '/resource/resources':
      titles = ['Agents'];
      routes = ['/'];
      break;
    case '/resource/resource':
      titles = ['Agents', 'Fiche agent'];
      routes = ['/', `/resource/resources`, location.pathname];
      setLastSearch(location.search);
      break;
    case '/resource/resource/documents':
      titles = ['Agents', 'Fiche agent', 'Documents'];
      routes = ['/', `/resource/resources`, `/resource/resource${lastSearch}`, `/resource/resource/documents`];
      break;
    case '/resource/edit-resource':
      titles = ['Agents', resourceId ? "Modifier l'agent" : 'Créer un agent'];
      routes = ['/', '/resource/resources', location.pathname];
      break;
    case '/site/sites':
      titles = ['Sites'];
      routes = ['/'];
      setLastSearch('');
      break;
    case '/site/site':
      if (user.userPartnerId) {
        titles = ['Plannings', 'Fiche site'];
        routes = ['/', '/site-schedule', location.pathname];
      } else {
        titles = ['Sites', 'Fiche site'];
      }
      if (user.userClientId) {
        routes = ['/', location.pathname];
      } else if (!user.userPartnerId) {
        routes = ['/', `/site/sites${lastSearch}`, location.pathname];
      }
      if (location.search) {
        setLastSearch(location.search);
      }
      break;
    case '/site-schedule':
      if (user.userClientId && !isPartner) {
        titles = ['Sites', 'Planning site'];
        routes = ['/', '/site/site', location.pathname];
      } else if (isPartner) {
        titles = ['Planning site'];
        routes = [location.pathname];
      } else {
        titles = ['Sites', 'Planning site'];
        routes = ['/', `/site/sites${lastSearch}`, location.pathname];
      }
      break;

    // Settings
    case '/settings':
      titles = ['Paramètres'];
      routes = ['/', location.pathname];
      break;
    case '/settings/notifications':
      titles = ['Paramètres', 'Notifications'];
      routes = ['/', '/settings', location.pathname];
      break;
    case '/settings/password':
      titles = ['Paramètres', 'Nouveau mot de passe'];
      routes = ['/', '/settings', location.pathname];
      break;

    // Admin pages
    case '/admin/permissions':
      titles = ['Droits d’accès'];
      routes = ['/'];
      break;

    case '/admin/users':
      titles = ['Utilisateurs'];
      routes = ['/'];
      break;

    // Pages manager
    case '/manager':
      titles = ['Tableau de bord'];
      routes = ['/'];
      setLastSearch(location.search);
      break;
    case '/manager/print/shifts':
    case '/manager/print/signatures':
      titles = ['Impressions'];
      setLastSearch(location.search);
      break;
    case '/clockings/devices':
      titles = ['Fiche site', 'Appareils de pointages'];
      routes = ['/site/site', location.pathname];
      setLastSearch(location.search);
      break;
    case '/services':
      titles = ['Pointages'];
      routes = ['/'];
      setLastSearch(location.search);
      break;

    // Pages agent
    case '/availabilities':
      titles = ['Disponibilités'];
      break;
    case '/demands':
      titles = ['Demandes'];
      break;
    case '/missions':
      titles = ['Missions'];
      break;
    case '/resource':
      titles = ['Tableau de bord'];
      routes = ['/'];
      break;
    case '/schedule':
      titles = ['Planning'];
      break;
    case '/sheet':
      titles = ['Ma fiche'];
      break;

    // Pages client
    case '/invoices':
      titles = ['Factures'];
      routes = ['/'];
      break;
    case '/client':
      titles = ['Tableau de bord'];
      routes = ['/'];
      break;
    case '/client/documents':
      titles = ['Mes documents'];
      routes = ['/'];
      break;
    case '/providers':
      titles = ['Mes prestataires'];
      routes = ['/'];
      break;
    case '/provider':
      titles = ['Mes prestataires', 'Mon prestataire'];
      routes = ['/', '/providers', location.pathname];
      setLastSearch(location.search);
      break;
    case '/provider/documents':
      titles = ['Mon prestataire', 'Documents'];
      routes = ['/', `/provider${lastSearch}`, '/provider/documents'];
      break;
    case '/quotes':
      titles = ['Devis'];
      routes = ['/'];
      break;

    // Partenaire
    case '/partner':
      titles = ['Tableau de bord'];
      routes = ['/'];
      break;
    case '/demands/partner':
      titles = ['Demandes'];
      break;
    case '/orders':
      titles = ['Commandes'];
      break;
    case '/orders/order':
      titles = ['Commandes', 'Commande'];
      routes = ['/', '/orders', location.pathname];
      break;
    case '/partner/myCompany':
      setLastSearch(location.search);
      titles = ['Ma société'];
      routes = ['/', '/myCompany'];
      break;
    case '/partner/myCompany/documents':
      titles = ['Ma société', 'Documents'];
      routes = ['/', `/partner/myCompany${lastSearch}`, '/partner/myCompany/documents'];
      break;
    case '/partner/partners':
      titles = ['Partenaires'];
      routes = ['/', '/partner/partners'];
      break;
    case '/partner/partner':
      setLastSearch(location.search);
      titles = onePartner ? ['Partenaires', 'Partenaire'] : ['Partenaire'];
      routes = ['/', '/partner/partners', location.pathname];
      break;
    case '/partner/partner/documents':
      titles = onePartner ? ['Partenaires', 'Partenaire', 'Documents'] : ['Partenaire', 'Documents'];
      routes = onePartner
        ? ['/', '/partner/partners', `/partner/partner${lastSearch}`, '/partner/partner/documents']
        : ['/', `/partner/partner${lastSearch}`, '/partner/partner/documents'];
      break;

    // Pages pointages
    case '/pointages':
    case '/pointages/': {
      const isMce = localStorage.getItem('comete_device_type') === 'mce';
      titles = [isMce ? 'Main courante électronique' : 'Prise et fin de services'];
      routes = ['/'];
      break;
    }
    case '/pointages/home':
    case '/pointages/client-home':
    case '/pointages/manager-home': {
      // Le nom du site MCE est ajouté après "Tableau de bord" (cf. planning du site
      // pour la même règle). Fallback gracieux sans suffixe si pas encore chargé.
      const suffixDashboard = clockingDeviceSiteName ? ` - ${clockingDeviceSiteName}` : '';
      titles = [`${i18n.t('common:ontime_dashboard.page_title')}${suffixDashboard}`];
      routes = [location.pathname];
      break;
    }
    case '/pointages/planning':
      titles = ['Planning'];
      routes = [location.pathname];
      break;
    case '/pointages/manager-planning':
    case '/pointages/site-planning':
    case '/pointages/client-planning': {
      const suffix = clockingDeviceSiteName ? ` - ${clockingDeviceSiteName}` : '';
      titles = [`${i18n.t('common:clocking_page.site_planning_title')}${suffix}`];
      routes = [location.pathname];
      break;
    }
    case '/pointages/consignes-documents':
      titles = ['Consignes & documents'];
      routes = [location.pathname];
      break;
    case '/pointages/recent-activities':
      titles = ['Activités récentes'];
      routes = [location.pathname];
      break;
    case '/pointages/mce/manager/events':
      titles = ['Main courante'];
      routes = [location.pathname];
      break;
    case '/pointages/mce/resource/events':
      titles = ['Évènements'];
      routes = [location.pathname];
      break;
    case '/pointages/mce/resource/patrols':
      titles = ['Rondes'];
      routes = [location.pathname];
      break;
    case '/pointages/app-disabled':
      titles = ['Application inactive'];
      routes = ['/'];
      break;
    case '/pointages/shift':
      titles = ['Vacation'];
      routes = ['/', location.pathname];
      break;
    case '/pointages/clockables-shifts-list': {
      const isMce2 = localStorage.getItem('comete_device_type') === 'mce';
      titles = [isMce2 ? 'Main courante électronique' : 'Prise et fin de services', 'Vacations pointables'];
      routes = ['/', location.pathname];
      break;
    }
    case '/pointages/clockings-shifts-lists': {
      const isMce3 = localStorage.getItem('comete_device_type') === 'mce';
      titles = [isMce3 ? 'Main courante électronique' : 'Prise et fin de services', 'Vacations du site'];
      routes = ['/', location.pathname];
      break;
    }
    case '/pointages/init':
      titles = ['Initialisation'];
      routes = ['/'];
      break;
    case '/pointages/login':
      titles = ['Connexion'];
      routes = ['/'];
      break;
    case '/pointages/pairing':
      titles = ["Associer l'appareil"];
      routes = ['/'];
      break;
    case '/pointages/settings':
      titles = ["Associer l'appareil", 'Configuration'];
      routes = ['/pointages/pairing', location.pathname];
      break;
    case '/pointages/forgot-clocking-code':
      titles = ['Code oublié'];
      routes = ['/', location.pathname];
      break;
    case '/pointages/sites-management':
      titles = ['Gestion des sites associés'];
      routes = ['/', location.pathname];
      break;

    // MCE
    // Espace Agent
    case '/mce/resource/events':
      titles = ['Évènements'];
      routes = ['/'];
      break;
    case '/mce/resource/patrols':
      titles = ['Rondes'];
      routes = ['/'];
      break;

    // Espace Manager
    case '/mce/manager/events':
      titles = ['Main courante'];
      routes = ['/'];
      break;
    case '/mce/manager/forms':
      titles = ['Formulaires'];
      routes = ['/'];
      break;
    case '/mce/manager/patrols':
      titles = ['Rondes'];
      routes = ['/'];
      break;
    case '/mce/manager/forms/create':
      titles = ['Formulaires', 'Créer un formulaire'];
      routes = ['/', '/mce/manager/forms', location.pathname];
      break;
    case '/mce/manager/forms/update':
      titles = ['Formulaires', 'Modifier un formulaire'];
      routes = ['/', '/mce/manager/forms', location.pathname];
      break;
    case '/mce/manager/entries':
      titles = ['Formulaires', 'MCE remplis'];
      routes = ['/', '/mce/manager/forms', location.pathname];
      break;

    default:
      titles = [''];
  }

  return { routes, titles };
};

export default getRoutesAndTitles;
